import React, {
    useContext,
    useState,
    useEffect,
} from 'react';
import { useQuery, useMutation } from '@tanstack/react-query';

import { refetchBasketData, NotificationContext, handleError } from '../router'

import * as OPTIONS from "../option-fields";
import * as QUERIES from "../query-functions";

import LoadingIndicator from '../components/loading-indicator';

const membershipId = OPTIONS.discountAvailable.membership?.innerHTML;

export default function MembershipPrompt(props) {

    const {notification, setNotification} = useContext(NotificationContext);
    
    const { 
        isFetching: isPotentialDiscountDataFetching,
        data: potentialDiscountData,
    } = useQuery({
        queryKey: ['potentialDiscountData', membershipId],
        queryFn: () => QUERIES.getPotentialDiscount(membershipId),
        refetchOnWindowFocus: false,
        retry: false
    });

    const addMembership = useMutation({
        mutationFn: () => QUERIES.addMembership([{membership: membershipId, autoRenew: true}]),
        onError: (error) => {
            handleError(error.message, setNotification);
        },
        onSuccess: (data) => {
            refetchBasketData();
        },
    });

    if (!props.basketData || isPotentialDiscountDataFetching) return;
    
    return (
        <section className='membership-prompt'>
            <div className='membership-prompt--inner'>
                {props.basketData.membershipSubscriptions?.length ?
                    <>
                        <h2 className='booking-pathway__header'>Thanks for joining us</h2>
                        <div className='membership-prompt--description'>
                            <p>Friends of Capital Theatres can see more of what they love for less and enjoy early booking with our Friends membership offers.</p>
                        </div>
                    </>
                : potentialDiscountData?.totalDiscount ?
                    <>
                        <h2 className='booking-pathway__header'>{`Save £${potentialDiscountData.totalDiscount.toFixed(2)} on your order`}</h2>
                        {OPTIONS.discountAvailable.introduction?.innerHTML &&
                            <div className='membership-prompt--description' dangerouslySetInnerHTML={{__html: OPTIONS.discountAvailable.introduction.innerHTML}}></div>
                        }
                        <div className='membership-prompt--button'>
                            <button type="button" className='btn' onClick={() => addMembership.mutate()}>Become a friend</button>
                        </div>
                    </>
                :
                    <>
                        {OPTIONS.noDiscountAvailable.title?.innerHTML &&
                            <h2 className='booking-pathway__header'>{OPTIONS.noDiscountAvailable.title.innerHTML}</h2>
                        }
                        {OPTIONS.noDiscountAvailable.introduction?.innerHTML &&
                            <div className='membership-prompt--description' dangerouslySetInnerHTML={{__html: OPTIONS.noDiscountAvailable.introduction.innerHTML}}></div>
                        }
                        {OPTIONS.noDiscountAvailable.button?.innerHTML &&
                            <div className='membership-prompt--button' dangerouslySetInnerHTML={{__html: OPTIONS.noDiscountAvailable.button.innerHTML}}></div>
                        }
                    </>
                }
            </div>
        </section>
    )
}